import React, { Component } from 'react';
import MainLayout from "../common/MainLayout";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as pageActions from "../../actions/pages";

class Overview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageName: 'OVERVIEW'
        };
    }
    componentDidMount() {

        let data = {"name" : this.state.pageName};
        this.props.setPage(data);
    }


    render() {
        return(
            <MainLayout pageName= {this.state.pageName} />
        )
    }

}
export default  withRouter(connect(null, {
    setPage : pageActions.setPage
})(Overview));



// WEBPACK FOOTER //
// ./src/components/overview/Overview.js